import { NodeViewWrapper } from "@tiptap/react";
import clientApproach from '../../../../../assets/images/whtchoosemalmart/icon-approach.png'
import communication from '../../../../../assets/images/whtchoosemalmart/icon-communication.png'
import data from '../../../../../assets/images/whtchoosemalmart/icon-data.png'
import dataProcess from '../../../../../assets/images/whtchoosemalmart/icon-process.png'
import clientProfessionals from '../../../../../assets/images/whtchoosemalmart/icon-professionals.png'
import trackRecord from '../../../../../assets/images/whtchoosemalmart/icon-track-record.png'

const whyChooseData = [
    {
      imagePath: clientProfessionals,
      title: "Experienced Industry Professionals",
      description:
        "Skilled experts with deep industry knowledge and hands-on experience.",
    },
    {
      imagePath: communication,
      title: "Transparent Communication",
      description:
        "Clear, honest communication at every stage with no hidden gaps.",
    },
    {
      imagePath: data,
      title: "Data-Driven Decision Making",
      description:
        "Every decision backed by insights, data, and practical analysis.",
    },
    {
      imagePath: trackRecord,
      title: "Proven Track Record of Success",
      description:
        "Consistent delivery of successful projects with reliable outcomes.",
    },
    {
      imagePath: clientApproach,
      title: "Client-First Approach",
      description:
        "Your needs, preferences, and goals stay at the center of everything.",
    },
    {
      imagePath: dataProcess,
      title: "Structured Process",
      description:
        "A clear, structured process designed for smooth and efficient execution.",
    },
];

export const WhyChooseUsBlockView = (props) => {
    const { editor, getPos } = props;

    const handleCaptionClick = () => {
        const nodePosition = getPos();
        editor.commands.setNodeSelection(nodePosition);
    };

    return (
        <NodeViewWrapper data-type='whychooseus'>
            <div className="whychoosemalmart-node-wrapper">
                <div onClick={handleCaptionClick}>
                    <div className='whychoosemalmart-content'>
                        <div className="whychooseus-grid">
                            {whyChooseData.map((item, index) => (
                                <div key={index} className="whychooseus-item">
                                    <div className="whychooseus-image">
                                        <img src={item.imagePath} alt={item.title} />
                                    </div>
                                    <h3 className="whychooseus-title">{item.title}</h3>
                                    <p className="whychoosemalmart-description">{item.description}</p>
                                </div>
                            ))}
                        </div>
                    </div>
                </div>
            </div>
        </NodeViewWrapper>
    );
};